import Sap from "@/features/sap/Sap"

const SapPage = () => {
  return <Sap />
}

export default SapPage
